module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch2"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch2.jpg",
      "width": "12%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“Billy? Billy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I bobbed up to the surface, pulled off my snorkel, and raised the mask. I stared into the sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I saw my uncle. He was leaning over the rail of his boat, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cassandra")]), _vm._v(". He stared down at me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Billy? What are you doing down there?” he called.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh … just pretending stuff,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Was that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("seaweed")]), _vm._v(" you were fighting?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t know he was watching. “I thought maybe it was an eel,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He chuckled. “Well, you gave it a beating it won’t forget!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D thinks my superhero fantasies are funny. “Climb up here,” he shouted. “You’ve been pestering me for weeks to teach you how to use the fishing spear. This seems like a good time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Awesome!” I cried. I turned and kicked my way toward the ladder at the stern of the boat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cassandra")]), _vm._v(" is a long white boat, the size of a small house. It’s actually a sea lab, three decks tall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The lower deck has sleeping cabins for us and the crew, storage compartments, and the galley, where we cook our meals and eat together.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The main deck is filled with research cabins and study labs and all kinds of radar and computer equipment. At the front of the top deck is the pilot’s cabin, with the wheel and other controls. Behind that is an observation deck with even more electronic equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My uncle is a marine biologist. He studies tropical fish and undersea plants. He spends a lot of time looking for fish and plants that haven’t been discovered yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D helped pull me onto the deck. He laughed when I splashed water over the front of his white lab coat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tossed my snorkel, mask, and fins into the metal bin near the rail. Then I pulled off the wet suit and tossed it in, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My uncle’s name is George Deep, but everybody calls him Dr. D. Even my dad — his brother — calls him Dr. D.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dad says everyone called George that back when he was ten years old. That’s because he was always studying bugs and dirt and tree leaves and stuff, even when he was just a kid.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D is short and thin. He wears thick black-rimmed glasses, he has curly brown hair and a bald spot on top of his head, and the expression on his face is almost always serious.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wears a long white lab coat with a dozen pockets. He looks just the way a scientist should look.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He put a hand on my shoulder and led me along the side of the deck. “How was the water?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kinda wet,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He chuckled. It was a little joke we shared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He raised the long metal fishing spear. “Know what this is?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A toothpick for a whale?” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He laughed again. “Let’s get serious, Billy. This is a very dangerous weapon.” He wrapped my hand around the end. “Hold it like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yes!")]), _vm._v(" I thought. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Undersea Mutant raises the Pulverizer — my Death Spear made of super-charged lightning!")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D took the spear from me. He wrapped his hand around it and raised it over his head. “Billy, watch carefully. This is how you throw it. See how I have it balanced?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pulled back — and heaved the spear into the water. I watched it cut through the surface without making a splash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. D had attached a long rope to the back of the spear. He used it to pull the spear onto the boat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It takes a while to get the feel of it,” he told me. “Get the right balance first. Then aiming it will be a lot easier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He handed the spear to me. “It’s heavier than you thought, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s light as a feather to the Undersea Mutant")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah. Kinda heavy,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He slid my hand closer to the middle of the shaft. “Hold it here,” he said. “Go ahead. Get it balanced, then give it a try.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I gripped the spear tightly. I stared over the rail, into the sparkling water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I took a deep breath. I pulled my arm back as far as it would go — and I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("heaved")]), _vm._v(" the spear with all my might.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“HELLLLLP!” a shrill voice shrieked from the water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My little sister, Sheena!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“HELLLP! You HIT me!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a019c57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545840330_ch002.vue
// module id = 75
// module chunks = 0